import React from "react";
import PropTypes from "prop-types";
const RotateIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"}>
        <path
          fillRule="nonzero"
          d="M17 10a1 1 0 0 1-2 0 6 6 0 1 0-6 6 1 1 0 0 1 0 2 8 8 0 1 1 8-8z"
        />
        <path d="M12.407 8.536a1 1 0 0 1 1.414 0l2.122 2.12 2.121-2.12a1 1 0 0 1 1.414 1.414l-2.828 2.828a1 1 0 0 1-1.414 0L12.407 9.95a1 1 0 0 1 0-1.414z" />
      </g>
    </g>
  </svg>
);
RotateIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default RotateIcon;
